
@if(loading){
  <div class="page-loader spinner-transparent">
    <mat-spinner></mat-spinner>
  </div>
}@else{
<div class="content">
<div>
  <mat-card-header>
    <mat-card-title>Criar Produto</mat-card-title>
  </mat-card-header>
    <div class="edit-box">
        <mat-form-field class="example-full-width">
          <mat-label>Nome</mat-label>
          <input (input)="kit.titulo = setValue($event);" matInput placeholder="" [value]="kit.titulo">
        </mat-form-field>

         <mat-form-field class="example-full-width">
          <mat-label>Produto</mat-label>
          <input (input)="kit.subtitulo =  setValue($event);" matInput placeholder="" [value]="kit.subtitulo">
        </mat-form-field>


        <mat-form-field class="example-full-width">
          <mat-label>Descrição resumo</mat-label>
          <textarea matInput
            cdkTextareaAutosize
            cdkAutosizeMinRows="3"
            [(ngModel)]="kit.descricao_resumo"
            placeholder="">
          </textarea>
        </mat-form-field>

        <mat-form-field class="example-full-width">
          <mat-label>Descrição completa</mat-label>
          <textarea matInput
            cdkTextareaAutosize
            cdkAutosizeMinRows="3"
            [(ngModel)]="kit.descricao"
            placeholder="">
          </textarea>
        </mat-form-field>

      <app-searchable-select
        [options]="specialties"
        [selected]="kit.especialidades_elegiveis || []"
        (selectedChange)="kit.especialidades_elegiveis = $event"
        label="Especialidades"
        [multiple]="true">
      </app-searchable-select>

      <app-searchable-select
        [options]="regionOptions"
        [selected]="kit.regioes_elegiveis || []"
        (selectedChange)="kit.regioes_elegiveis = $event"
        label="Regiões"
        [multiple]="true">
      </app-searchable-select>


        <mat-form-field class="example-full-width">
          <mat-label>Estoque</mat-label>
          <input matInput placeholder="" [(ngModel)]="kit.estoque">
        </mat-form-field>
  </div>


    </div>

    <mat-card class="example-card" appearance="outlined">
    <mat-card-content>
      <input type="file" hidden #f_input (change)="handleFileInputChange(f_input.files!)" accept="image/*" />

      @if (previewUrl) {
        <div class="preview-container" (click)="f_input.click()">
          <img [src]="previewUrl" alt="" class="preview-img">
          <div class="preview-overlay">
            <mat-icon>swap_horiz</mat-icon>
            <span>Trocar imagem</span>
          </div>
        </div>
      } @else {
        <div class="dropzone"
             [class.dragging]="isDragging"
             (click)="f_input.click()"
             (dragover)="onDragOver($event)"
             (dragleave)="onDragLeave($event)"
             (drop)="onDrop($event)">
          <mat-icon>cloud_upload</mat-icon>
          <p>Arraste uma imagem ou clique para enviar</p>
        </div>
      }

      <hr class="section-divider">

      <div class="info-section">
        <h3>Regiões</h3>
        <div class="chips-container">
          @for (regiao of kit.regioes_elegiveis ; track $index){
            <span class="chip">{{regiao}}</span>
          }
        </div>
      </div>

      <div class="info-section">
        <h3>Especialidades</h3>
        <div class="chips-container">
          @for (description of getSpecialtyDescriptionsArray(kit.especialidades_elegiveis) ; track $index){
            <span class="chip">{{description}}</span>
          }
        </div>
      </div>
    </mat-card-content>
  </mat-card>

</div>

<div class="button-group">
  <button (click)="save()" class="edit-btn" matButton="filled">Salvar</button>
  <button (click)="goToProducts()" class="inativar-btn" matButton="outlined">Voltar</button>
</div>
}
